import MenuItem from '@mui/material/MenuItem';
import { 
  GridColDef,
  useGridApiContext,
  gridVisibleColumnFieldsSelector,
  gridVisibleColumnDefinitionsSelector,
  gridFilterModelSelector,
  gridSortModelSelector
} from '@mui/x-data-grid-pro';
import { IColumn } from 'json-as-xlsx';
import React from 'react';

import { ExcelExportMenuItemProps } from './ExcelExportMenuItem.props';
import { ListType } from '../../../@types';
import { useExportFile } from '../../../queries/uploadedfiles-query';
import { getSelectedColumnNames } from '../../../utils/columnSelectionOperations';
import { downloadFile } from '../../../utils/file-utils';

export const ExcelExportMenuItem: React.FC<ExcelExportMenuItemProps> = ({
  label,
  fileName,
  fileType,
  structureTypeCategory,
  columnSelectionData,
  sortModel,
  startDate,
  endDate,
  serialSearch,
  locationId,
  includeChilds,
  setExportStatus,
  rowCount,
  defaultExcludedColumns,
  serialPartsManifestData,
  nonSerialPartsManifestData,
  pageSize,
  columnOrder,
  replenishmentFilterData,
  defaultReport,
  multiSearchQuery,
  obfuscation
}) => {
  const apiRef = useGridApiContext();
  const exportFile = useExportFile();

  const getExcludedColumns = () => {
    if (fileName === ListType.StructureList) {
      return getSelectedColumnNames(columnSelectionData, []);
    } else if (fileName === ListType.ClientContractList) {
      return getSelectedColumnNames(columnSelectionData, defaultExcludedColumns);
    } else if (fileName === ListType.PartList) {
      return getSelectedColumnNames(columnSelectionData);
    }
  };

  const downloadExcelFile = async () => {
    const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);
    const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);
    const filter = replenishmentFilterData || gridFilterModelSelector(apiRef);
    const sorting = gridSortModelSelector(apiRef);

    const columns = visibleColumns.map((obj: GridColDef) => {
      return { label: obj.headerName, value: obj.field } as IColumn;
    });
    
    setExportStatus('Export in progress... please wait...');
    try {
      const data: any = {
        selectedColumns: columns, 
        filter: filter,
        fileName: fileName,
        visibleColumnsField: visibleColumnsField,
        fileType: fileType,
        structureTypeCategory: structureTypeCategory,
        columnSelectionData: columnSelectionData,
        sorting: sorting.length ? sorting : sortModel,
        startDate,
        endDate,
        serialSearch,
        locationId,
        includeChilds,
        rowCount,
        serialPartsManifestData,
        nonSerialPartsManifestData,
        pageSize,
        columnOrder,
        defaultReport,
        multiSearchQuery,
        obfuscation
      };
      if (fileName === ListType.StructureList || fileName === ListType.ClientContractList || fileName === ListType.PartList) {
        data.excludedColumns = getExcludedColumns();
      }
      const exportFileLink: any = await exportFile.mutateAsync(data);
      if (exportFileLink?.sendEmail) {
        setExportStatus(exportFileLink?.message);
        return;
      }
      downloadFile(exportFileLink.url, fileName);
      setExportStatus('Export Successful!');
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      setExportStatus('Export Failed!');
    }
  };

  return (
    <MenuItem
      onClick={downloadExcelFile}
    >
      {label}
    </MenuItem>
  );
};
